import * as React from 'react';
import classNames from 'classnames';
import ReactPlayer from 'react-player';

import { Image } from '../../types';

import s from './HeroVideo.module.scss';

export interface HeroVideoProps {
    title?: string;
    heroVideoUrl?: string;
    featuredImage?: Image;
    heroBottomImage?: Image;
    heroInfoBox?: string;
    heroInfoBoxUrl?: string;
    heroInfoBoxUrlText?: string;
}

const HeroVideo: React.FC<HeroVideoProps> = ({
    title,
    featuredImage,
    heroVideoUrl,
    heroBottomImage,
    heroInfoBox,
    heroInfoBoxUrl,
    heroInfoBoxUrlText,
}) => {
    const [isReady, setIsReady] = React.useState(!heroVideoUrl);
    const handleReady = () => {
        if(typeof document !== 'undefined') {
            document.querySelectorAll('iframe').forEach(i => i.tabIndex = -1)
            document.querySelectorAll('video').forEach(i => i.tabIndex = -1);
        }
        setIsReady(true);
    };

    const rootClasses = classNames(s.Root, {
        [s.RootReady]: isReady,
        [s.RootVideo]: heroVideoUrl,
        [s.RootSmall]: !heroInfoBox && !heroBottomImage && !heroVideoUrl,
        [s.RootHasBottom]: heroInfoBox || heroBottomImage,
    });

    const bottomClasses = classNames(s.Bottom, {
        [s.BottomNoImage]: !heroBottomImage
    });

    const infoClasses = classNames(s.Info, {
        [s.InfoExtraPadding]: heroInfoBoxUrl
    });

    return (
        <>
            <div id="HeroVideo" className={rootClasses}>
                <div className={s.Container}>
                    {heroVideoUrl && (
                        <ReactPlayer
                            className={s.Player}
                            url={heroVideoUrl}
                            width="100%"
                            height="100%"
                            loop={true}
                            muted={true}
                            playsinline={true}
                            playing
                            config={{
                                youtube: {
                                    playerVars: {
                                        showinfo: 0,
                                        autoplay: 1,
                                        loop: 1,
                                        controls: 0,
                                        modestbranding: 1,
                                        mute: 1,
                                    },
                                },
                                vimeo: {
                                    playerOptions: {
                                        autoplay: 1,
                                        controls: 0,
                                        muted: 1,
                                        loop: 1,
                                        dnt: 1,
                                    },
                                },
                            }}
                            onReady={handleReady}
                        />
                    )}
                    {featuredImage && (
                        <div
                            className={s.Image}
                            style={{
                                backgroundImage: `url(${featuredImage.src})`,
                            }}
                        />
                    )}
                </div>
                <div className={s.Content}>
                    <div className={s.ContentInner}>
                        <h1
                            className={s.Title}
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                    </div>
                </div>
            </div>
            <div>
                <div className={bottomClasses}>
                    {heroInfoBox && (
                        <div className={s.InfoWrapper}>
                            <div className={infoClasses}>
                                <div
                                    className={s.Wysiwyg}
                                    dangerouslySetInnerHTML={{
                                        __html: heroInfoBox,
                                    }}
                                />
                                {heroInfoBoxUrl && (
                                    <a
                                        className={s.SiteLink}
                                        href={heroInfoBoxUrl}
                                    >
                                        {heroInfoBoxUrlText || 'Besök sida'}
                                    </a>
                                )}
                            </div>
                        </div>
                    )}
                    {heroBottomImage && (
                        <div
                            className={s.BottomImage}
                            style={{
                                backgroundImage: `url(${heroBottomImage.src})`,
                            }}
                        >
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default HeroVideo;
